import { z } from 'zod'

import { journalEntrySchema } from 'api/types/journalEntryType'

export const erpSyncPreviewResponseSchema = z.object({
  journal_entries: z.array(journalEntrySchema).optional(),
  failures: z.array(z.tuple([z.any(), z.string()])).optional(),
})
